// src/data/allGames.js
import BASE_GAMES from "./baseGames";

const THOP_URL = "https://api.thopgames.com/games/ZIOxusCyaW1uaWQ%3D";

let allGamesCache = null;
let loadingPromise = null;

function mapThopGame(g) {
  const id = `thop_${g.gname}`;

  return {
    id,
    title: g.gname,
    description: g.gDesc,
    genre: g.category || "Other",
    image: g.thumbnail,
    tags: [],                 // Thop doesn't provide tags
    platforms: ["web"],       // all are HTML5 browser games
    webglPath: g.gUrl,        // play URL
    orientation: g.orientation || "",
    isWeb3: false,
    source: "Partner Games",
    _raw: g,
  };
}

function dedupeGames(games) {
  const seen = new Set();
  const result = [];

  for (const g of games) {
    const key = `${g.id}|${g.webglPath || ""}`;
    if (seen.has(key)) continue;
    seen.add(key);
    result.push(g);
  }

  return result;
}

export async function loadAllGames() {
  // Already loaded once
  if (allGamesCache) return allGamesCache;

  // Already in progress
  if (loadingPromise) return loadingPromise;

  loadingPromise = (async () => {
    let thopGames = [];

    try {
      const res = await fetch(THOP_URL);
      if (res.ok) {
        const data = await res.json();
        const list = Array.isArray(data) ? data : [data];

        const mappedRaw = list.map(mapThopGame);
        // dedupe within Thop
        thopGames = dedupeGames(mappedRaw);
        console.log(
          "Thop mapped unique games:",
          thopGames.map((g) => g.id)
        );
      } else {
        console.error("Thop API error:", res.status);
      }
    } catch (err) {
      console.error("Error fetching Thop Games:", err);
    }

    const merged = dedupeGames([...BASE_GAMES, ...thopGames]);
    allGamesCache = merged;
    loadingPromise = null;
    return merged;
  })();

  return loadingPromise;
}

// Synchronous snapshot (used as initial state)
export function getAllGamesSync() {
  return allGamesCache || BASE_GAMES;
}

export function isAllGamesLoaded() {
  return !!allGamesCache;
}
